import { useParams } from "react-router-dom";
import { useDevotionals } from "../data/devotionals";
import IndividualDevotional from "./individualdevotional";

const DevWrapper = () => {
  const { slug } = useParams();
  const { entries, loading, error } = useDevotionals();

  if (loading) return <h2>Loading…</h2>;
  if (error) return <h2>{error}</h2>;

  // Old links use the short slug (e.g. /exegesis/gospelofchrist); the id also works.
  const devpage = entries.find((s) => s.slug === slug || s.id === slug);
  if (!devpage) return <h2>Entry Not Found</h2>;

  return (
    <>
      <IndividualDevotional {...devpage} />
    </>
  );
};

export default DevWrapper;